// src/config/i18n.ts
// ★ Internationalization configuration — supported languages, labels, and defaults.

export type Language = 'en' | 'es';

export const SUPPORTED_LANGUAGES: Language[] = ['en', 'es'];

export const LANGUAGE_LABELS: Record<Language, string> = {
    en: 'English',
    es: 'Español',
};

export const DEFAULT_LANGUAGE: Language = 'en';

/** localStorage key for persisting the language preference */
export const LANGUAGE_STORAGE_KEY = 'preferred-language';
